import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function moon({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      stroke="black"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
    >
      <path
        stroke="none"
        d="M11.435 18.977l.08-.996-.08.996zm-1.72-.49l.977-.218-.976.217zM11.94 5.212l.564-.826-.564.826zM18 12a6 6 0 00-6-6V4a8 8 0 018 8h-2zm-6 6a6 6 0 006-6h2a8 8 0 01-8 8v-2zm-.486-.02c.16.014.322.02.486.02v2c-.217 0-.432-.009-.645-.026l.16-1.993zm-.548-1.764A5.997 5.997 0 0014 11h2c0 2.981-1.63 5.58-4.044 6.955l-.99-1.738zM14 11a5.993 5.993 0 00-2.623-4.96l1.127-1.652A7.993 7.993 0 0116 10.999h-2zm-2.645 8.975c-.51-.04-1.013-.078-1.39-.166-.347-.082-1.05-.317-1.226-1.104l1.953-.435a.652.652 0 00-.251-.383c-.072-.051-.105-.046-.016-.025a3.4 3.4 0 00.398.06c.19.02.414.038.691.06l-.159 1.993zm.601-2.02c-.634.362-1.025.586-1.258.76-.117.087-.12.108-.091.066a.67.67 0 00.085-.511l-1.953.435a1.335 1.335 0 01.22-1.059c.159-.229.37-.405.547-.537.355-.264.877-.56 1.46-.892l.99 1.738zM12 6c.45 0 .765-.321.857-.653a.882.882 0 00-.353-.96l-1.127 1.652a1.118 1.118 0 01-.45-1.221A1.11 1.11 0 0112 4v2z"
      />
      <path
        fill="none"
        strokeWidth="2"
        d="M5.4 10.2h0c.101.304.152.456.203.523a.5.5 0 00.794 0c.05-.067.102-.219.203-.523h0c.082-.245.123-.368.176-.479a2 2 0 01.945-.945c.111-.053.234-.094.479-.176h0c.304-.101.456-.152.523-.203a.5.5 0 000-.794c-.067-.05-.219-.102-.523-.203h0c-.245-.082-.368-.123-.479-.176a2 2 0 01-.945-.945A4.365 4.365 0 016.6 5.8c-.101-.304-.152-.456-.203-.522a.5.5 0 00-.794 0c-.05.066-.102.218-.203.522a4.365 4.365 0 01-.176.479 2 2 0 01-.945.945A4.365 4.365 0 013.8 7.4c-.304.101-.456.152-.522.203a.5.5 0 000 .794c.066.05.218.102.522.203.245.082.368.123.479.176a2 2 0 01.945.945c.053.111.094.234.176.479z"
      />
    </svg>
  );
}

export default moon;
